import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { FieldMetadata, SpecificFieldData, SpecificFieldMetadata } from 'models/forms/fields';

export function useField<Type extends FieldMetadata['type']>(id: string) {
  const metadata = useFieldMetadata<SpecificFieldMetadata<Type>>(id);
  const [data, setData] = useData<SpecificFieldData<Type>>(id);
  return { metadata, data, setData };
}
